import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import TSAdresse from './TSAdresse';

export default class TSGenossenschaftDaten extends TSAbstractEntity implements TSSerializable<TSGenossenschaftDaten> {

    private _name: string;

    private _adresse: TSAdresse;

    private _isSteuerpflichtig: boolean = true;

    constructor() {
        super();
        this._adresse = new TSAdresse();
    };

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get adresse(): TSAdresse {
        return this._adresse;
    }

    public set adresse(value: TSAdresse) {
        this._adresse = value;
    }

    public get isSteuerpflichtig(): boolean {
        return this._isSteuerpflichtig;
    }

    public set isSteuerpflichtig(value: boolean) {
        this._isSteuerpflichtig = value;
    }

    deserialize(restObject: any): TSGenossenschaftDaten {
        super.deserialize(restObject);
        this.adresse = this.deserializeOrCreate(restObject.adresse, new TSAdresse());
        this.name = restObject.name;
        this.isSteuerpflichtig = restObject.isSteuerpflichtig;
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.adresse = this.serializeOrInit(this.adresse, restObject.adresse);
        restObject.name = this.name;
        restObject.isSteuerpflichtig = this.isSteuerpflichtig;
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSGenossenschaftDaten.ts